import { Group } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import TagsAccountsPayableAndReceivableSelectModal from '@/components/Settings/Financial/TagsAccountsPayableAndReceivable/TagsAccountsPayableAndReceivableSelectModal';
import { useAccountPayableIncludeTag } from '@/core/domain/financial/AccountPayable/AccountPayable.hooks';
import { useDisclosure } from '@/hooks';
import { useAccountPayableContext } from '@/pages/FinancialPages/BillToPayPage/ReleasesPage/ReleasesDetailsPage';
import { truncateString } from '@/utils/functions/truncateString';
import { Button, Tooltip } from 'antd';
import { X } from 'react-feather';

export default function AccountPayableDetailHeaderTag() {
  const { accountPayableHook, accountPayable, currentInstallment } =
    useAccountPayableContext();
  const [modalSelectTag, modalSelectTagActions] = useDisclosure();

  const installment = accountPayable?.installmentPayables[currentInstallment];
  const installmentTag = installment?.installmentTag;

  const includeTag = useAccountPayableIncludeTag();

  async function handleComplementTag(installmentTagId?: number | null) {
    if (installment && accountPayable) {
      await includeTag.mutateAsync({
        accountPayableId: accountPayable.id,
        installmentPayableId: installment.id,
        installmentTagId,
      });
    }
  }

  return (
    <>
      {!!installmentTag ? (
        <Group gap={4}>
          <Tooltip title={installmentTag.name.toUpperCase() || ''}>
            <StatusTag
              size="lg"
              color={installmentTag.color}
              label={truncateString(installmentTag.name.toUpperCase(), 20)}
              onClick={modalSelectTagActions.open}
            />
          </Tooltip>

          <Button
            icon={<AntdFeatherIcon icon={<X cursor="pointer" />} size={14} />}
            size="small"
            onClick={() => handleComplementTag(null)}
            loading={includeTag.isLoading}
            disabled={accountPayableHook.isFetching}
          />
        </Group>
      ) : (
        <StatusTag
          color="default"
          size="lg"
          className="card-select-tag"
          label="Selecionar Etiqueta"
          onClick={modalSelectTagActions.open}
          disabled={includeTag.isLoading || accountPayableHook.isFetching}
        />
      )}

      <TagsAccountsPayableAndReceivableSelectModal
        onCancel={modalSelectTagActions.close}
        open={modalSelectTag}
        onCallback={handleComplementTag}
        confirmLoading={includeTag.isLoading}
      />
    </>
  );
}
